// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1YbPi","footer":"ModalInfo_footer__Bjd_k"};